import React, { Component, PropTypes } from 'react';

import './AutocompleteQueryTextHighlightOption.scss';

export default class AutocompleteQueryTextHighlightOption extends Component {
  static propTypes = {
    label: PropTypes.string,
    query: PropTypes.string,
  };

  static defaultProps = {
    query: '',
    label: '',
  };

  getParts() {
    const { label, query } = this.props;

    const parts = [];
    const queryIndex = label.toLowerCase().indexOf(query.toLowerCase());

    if (query !== '' && queryIndex !== -1) {
      parts.push(label.substring(0, queryIndex));
      parts.push(label.substring(queryIndex, queryIndex + query.length));
      parts.push(label.substring(queryIndex + query.length));
    } else {
      parts.push(label);
      parts.push('');
      parts.push('');
    }

    return parts;
  }

  render() {
    const [preMatch, match, postMatch] = this.getParts();

    return (
      <span>
        <span className="autocomplete-query-text-highlight-option__pre-match">{ preMatch }</span>
        <span className="autocomplete-query-text-highlight-option__query-match">{ match }</span>
        <span className="autocomplete-query-text-highlight-option__post-match">{ postMatch }</span>
      </span>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Autocomplete/AutocompleteQueryTextHighlightOption.jsx
 **/